import {
  START_COUNTDOWN,
  UPDATE_TIME,
} from "../actiontypes/TrainingTimeActionTypes";

const initialState = {
  startTime: null,
  initialRemainingTime: 15 * 60 * 60,
  remainingTime: 15 * 60 * 60,
};

const countdownReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_COUNTDOWN:
      return {
        ...state,
        startTime: action.payload,
        initialRemainingTime: state.remainingTime,
      };

    case UPDATE_TIME:
      return {
        ...state,
        remainingTime: action.payload,
      };

    default:
      return state;
  }
};

export default countdownReducer;
